import { render, staticRenderFns } from "./NoFile.vue?vue&type=template&id=07e64539&"
import script from "./NoFile.vue?vue&type=script&lang=js&"
export * from "./NoFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports